var path = '/app/pages/product/product.html';
var html = "<div class=container style=min-height:440px> <div uib-alert ng-if=ctrl.alerts.local.msg ng-class=\"'p-4 my-4 alert-' + (ctrl.alerts.local.type || 'info')\">{{ ctrl.alerts.local.msg }}</div> <ui-view></ui-view> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/product/product.html
// module id = 1177
// module chunks = 0